export default __webpack_public_path__ + "lite-ocrb71b28.jpg";